import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        marginBottom: theme.spacing(2)
      },
}))